// OpeningsTijden Form custom JS
// updateDisplay and createColorCustomLabelHTML are also used by single-product.js
// (the product_material change handler fills the OT color grid), so they are exported.

function measureText(text, font, fontSize) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize}px ${font}`;
    return context.measureText(text).width;
}

function escapeHTML(str) {
    return str.replace(/[&<>"']/g, char => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    })[char]);
}

function createSVG(title, color, font, rows) {
    const fixedWidthPx = 250;
    const padding = 0;
    const rowHeight = 25;
    const titleHeight = 30; // Reduced from 40
    let fontSize = 18;
    let titleFontSize = 18;

    let maxCol1Width = measureText(title, font, titleFontSize);
    let maxCol2Width = 0;

    rows.forEach(row => {
        const dayWidth = measureText(row.day, font, fontSize);
        const timeWidth = measureText(row.time, font, fontSize);
        maxCol1Width = Math.max(maxCol1Width, dayWidth);
        maxCol2Width = Math.max(maxCol2Width, timeWidth);
    });

    const col1Width = Math.ceil(maxCol1Width);
    const col2Width = Math.ceil(maxCol2Width);
    const contentWidth = col1Width + col2Width;

    const scale = fixedWidthPx / contentWidth;
    fontSize = Math.floor(fontSize * scale);
    titleFontSize = Math.floor(titleFontSize * scale);

    const totalHeight = titleHeight + (rows.length * rowHeight) + (padding * 2);

    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${fixedWidthPx}" height="${totalHeight}" viewBox="0 0 ${fixedWidthPx} ${totalHeight}">`;
    svg += `<style>text { font-family: ${font}; fill: ${color}; }</style>`;
    svg += `<text x="${padding}" y="${padding + 18}" font-size="${titleFontSize}" font-weight="bold">${escapeHTML(title)}</text>`;

    rows.forEach((row, i) => {
        const y = padding + titleHeight + (i * rowHeight) + 18;
        svg += `<text x="${padding}" y="${y}" font-size="${fontSize}">${escapeHTML(row.day)}</text>`;
        svg += `<text x="${padding + col1Width * scale}" y="${y}" font-size="${fontSize}">${escapeHTML(row.time)}</text>`;
    });

    svg += '</svg>';
    return svg;
}

export function updateDisplay() {
    const $ = jQuery;
    const $form = $('[data-function="custom_ot_form"]');
    const $display = $('.wc__single-custom-ot-display');

    const title = $form.find('input[type="text"]').first().val();
    const width = $('[data-function="custom_ot_select_width"] option:checked').text();
    let price = $('[data-function="custom_ot_select_width"] option:checked').data('price');
    const extra_price = parseFloat(String($('select[name="product_material"] option:checked').data('price')||'0').trim().replace(/\./g,'').replace(',','.')) || 0;

    price = price + extra_price;

    const color = $('input[name="custom_ot_select_color"]:checked').data('color');
    const font = $('[data-function="custom_ot_select_font"]').val();
    const rows = [];

    $form.find('[data-row]').each(function () {
        const uuid = $(this).data('row');
        const day = $form.find(`input[name="ot_day_${uuid}"]`).val();
        const time = $form.find(`input[name="ot_time_${uuid}"]`).val();

        if (day && time) {
            rows.push({ day, time });
        }
    });

    const titleHeight = 2.8;
    const rowHeight = 2.8;
    const rowGap = 1.15;

    const totalHeight = titleHeight + (rows.length * rowHeight) + ((rows.length - 1) * rowGap);
    const displayHeight = totalHeight.toFixed(2);

    const widthSteps = Math.max(0, (parseInt(width) - 40) / 8);
    const adjustedHeight = totalHeight + (widthSteps * 8);
    const adjustedDisplayHeight = adjustedHeight.toFixed(2);

    const containerScale = rows.length > 8 ? 1.10 : 1.5;

    const svgContent = createSVG(title, color, font, rows);

    const html = `
        <div class="wc__single-custom-ot-c" style="transform: scale(${containerScale});">
            <div class="wc__single-custom-ot-c-h-bar">
                <span>~${adjustedDisplayHeight}cm</span>
            </div>
            <div class="wc__single-custom-ot-c-w-bar">
                <span>~${width}</span>
            </div>
            <div class="wc__single-custom-ot-c-t u-inner-column u-gap-4">
                ${svgContent}
            </div>
        </div>
    `;

    var formatted = "€ " + Number(price).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    $('[data-function="custom_ot_price"]').text(formatted);

    $display.empty().append(html);
}

export function createColorCustomLabelHTML(color, thumbnail, index, type) {
    const checked = index === 0 ? 'checked' : '';

    return `
        <label
               for="${color.unique}"
               style="background-color:${color.hex};">
          <span>${color.label}</span>
          <input type="radio"
                 name="custom_ot_select_color"
                 id="${color.unique}"
                 value="${color.label}"
                 data-color="${color.hex}"
                 data-type="${type}"
                 ${checked}>
             <input type="hidden" name="unique_code" value="${color.unique}">
          ${thumbnail ? `<img src="${thumbnail}" alt="">` : ''}
        </label>
      `;
}

export default function () {

    const $ = jQuery;
    const $form = $('[data-function="custom_ot_form"]');

    $form.on('click', '[data-action="custom_ot_add_row"]', function (e) {
        e.preventDefault();

        const currentRows = $form.find('[data-row]').length;

        $('[data-function="custom_ot_error"]').text('');

        if (currentRows >= 12) {
            $('[data-function="custom_ot_error"]').text('Maximaal 12 regels toegestaan');
            return;
        }

        const uuid = Math.random().toString(36).substr(2, 5);
        const newRow = `
            <div class="u-inner-row u-inner-align-center u-gap-8" data-row="${uuid}">
                <input type="text" placeholder="" name="ot_day_${uuid}" value="">
                <input type="text" placeholder="" name="ot_time_${uuid}" value="">
                <div data-id="${uuid}" class="wc__single-custom-ot-text-trash">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                </div>
            </div>
        `;

        $form.find('.wc__single-custom-ot-text .u-inner-column.u-gap-8').append(newRow);
        updateDisplay();
    });

    $form.on('click', '.wc__single-custom-ot-text-trash', function () {

        const currentRows = $form.find('[data-row]').length;

        $('[data-function="custom_ot_error"]').text('');

        if (currentRows == 1) {
            $('[data-function="custom_ot_error"]').text('Minimaal 1 regel');
            return;
        }


        const uuid = $(this).data('id');
        $('[data-function="custom_ot_error"]').text('');
        $form.find(`[data-row="${uuid}"]`).remove();
        updateDisplay();
    });

    $form.on('input', 'input[type="text"]', updateDisplay);
    $('[data-function="custom_ot_select_width"]').on('change', updateDisplay);
    $(document).on('change', 'input[name="custom_ot_select_color"]', updateDisplay);
    $('[data-function="custom_ot_select_font"]').on('change', updateDisplay);

    $('[data-action="add_custom_ot_to_cart"]').on('click', function (e) {
        const rows = [];
        const headerText = $('[data-function="custom_ot_form"] input[type="text"]').first().val() || null;

        rows.push([headerText, null]);

        $('[data-action="data_rows"]').each(function () {
            const day = $(this).find('input[name^="ot_day"]').val();
            const time = $(this).find('input[name^="ot_time"]').val();
            rows.push([day, time]);
        });

        const variation_id = $('[data-function="custom_ot_select_width"]').val();
        const heightBarCM = $('.wc__single-custom-ot-c-h-bar span').text();
        const selectedFont = $('[data-function="custom_ot_select_font"]').val();
        const selectedMirror = $('[data-function="custom_ot_mirror"]').val();
        const selectedMaterial = $('select[name="product_material"]').val();
        const selectedMaterialPrice = $('select[name="product_material"] option:checked').data('price');
        const qty = $('input[name="product_quantity"]').val();
        const svg = $('.wc__single-custom-ot-c-t').find('svg')[0].outerHTML;

        const selectedColor = $('input[name="custom_ot_select_color"]:checked');
        const colorData = {
            id: selectedColor.attr('id'),
            value: selectedColor.val(),
            color: selectedColor.data('color')
        };

        // Convert SVG to Base64 using Blob + FileReader
        const svgBlob = new Blob([svg], { type: "image/svg+xml" });
        const reader = new FileReader();
        reader.onloadend = function () {
            const svgBase64 = reader.result; // This will be "data:image/svg+xml;base64,..."

            const data = {
                svg: svgBase64, // send Base64 version
                opening_hours: rows,
                variation_id: variation_id,
                font: selectedFont,
                material: selectedMaterial,
                mirror: selectedMirror,
                price_material: selectedMaterialPrice,
                color: colorData,
                quantity: qty,
                height_bar_cm: heightBarCM,
            };

            let $btn = $(this);

            $.ajax({
                type: 'POST',
                url: ajaxURL,
                data: {
                    nonce: ajaxNonce,
                    data: data,
                    action: 'add_ot_product_to_cart',
                },
                beforeSend: function () {
                    $btn.addClass('updating');
                },
                success: function (response) {
                    if (response.success) {
                        window.location.href = response.data.cart_url;
                    }
                },
                complete: function () {
                    $btn.removeClass('updating');
                }
            });
        };
        reader.readAsDataURL(svgBlob); // converts Blob to Base64 data URI
    });

}
